import { BsBuildings, BsGlobe, BsInfo } from "react-icons/bs";
import { RiShieldUserLine } from "react-icons/ri";
import COSquare from "./COSquare";
import "../../../assets/css/admin/countries and offices/CountriesOffices.css";
import { useState, useEffect } from "react";
import CountriesDialog from "./countries/CountriesDialog";
import OfficesDialog from "./offices/OfficesDialog";
import EntitiesDialog from "./entities/EntitiesDialog";
import { Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import fetchClient from "../../../axios/fetch";
import { useTranslation } from "react-i18next";

const CountriesOffices = () => {
  const { t } = useTranslation();

  const [countries, setCountries] = useState([
    {
      id: 1,
      name:
        localStorage.getItem("country_code") === "ph" ? "Philippines" : "Colombia",
    },
  ]);
  const [offices, setOffices] = useState([]);
  const [entities, setEntities] = useState([]);

  // determines which list of contents to display
  const [selectedOpt, setSelectedOpt] = useState("");

  const [visibleDialog, setVisibleDialog] = useState({
    countries: false,
    offices: false,
    entities: false,
  });

  const [selected, setSelected] = useState({
    country: null,
    office: null,
    entities: null,
  });

  // sets edit or create when opening modal
  const [mode, setMode] = useState("");

  const [notif, setNotif] = useState({
    type: "success",
    msg: "",
  });

  useEffect(() => {
    getOffices();
    getEntities();
  }, []);

  useEffect(() => {
    let lastCity = localStorage.getItem("city");

    const handleStorage = (event) => {
      if (event.key === "city") {
        lastCity = event.newValue;
        getEntities();
        getOffices();
      }
    };

    const cityWatcher = setInterval(() => {
      const currentCity = localStorage.getItem("city");
      if (currentCity !== lastCity) {
        lastCity = currentCity;
        getEntities();
        getOffices();
      }
    }, 500);

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(cityWatcher);
    };
  }, []);

  const getOffices = () => {
    fetchClient()
      .get("api/office")
      .then((res) => {
        const filterByCity = res.data.data.filter((office) =>
          office.cityId === parseInt(localStorage.getItem("city"))
        );
        setOffices(filterByCity);
      });
    // .catch(err); //=> console.log(err));
  };

  const getEntities = () => {
    fetchClient()
      .get(`api/entity/city/${localStorage.getItem("city")}`)
      .then((res) => {
        const fetchedEntities = res?.data?.data || [];
        setEntities(fetchedEntities.length > 0 ? fetchedEntities : []);
      })
      .catch(() => {
        setEntities([]);
      });
  };

  const toggleDialog = () => {
    if (selectedOpt === "countries") {
      setVisibleDialog((prev) => ({
        ...prev,
        countries: !prev.countries,
      }));
    } else if (selectedOpt === "entities") {
      setVisibleDialog((prev) => ({ ...prev, entities: !prev.entities }));
    } else {
      setVisibleDialog((prev) => ({ ...prev, offices: !prev.offices }));
    }
  };

  const changeSelected = (e) => {
    setSelectedOpt(e.currentTarget.dataset.option || "countries");
  };

  const setCreateMode = () => {
    setMode("create");
    toggleDialog();

    // no country/office will be passed to the dialog in create mode

    if (selectedOpt === "countries") {
      setSelected((prev) => ({
        ...prev,
        country: null,
      }));
    } else if (selectedOpt === "entities") {
      setSelected((prev) => ({
        ...prev,
        entities: null,
      }));
    } else {
      setSelected((prev) => ({
        ...prev,
        office: null,
      }));
    }

    // selectedOpt === "countries"
    //   ? setSelected({
    //       ...selected,
    //       country: null,
    //     })
    //   : setSelected({
    //       ...selected,
    //       office: null,
    //     });
  };

  const setEditMode = () => {
    setMode("edit");
    toggleDialog();
  };

  const selectItem = (e) => {
    const selectedText = e.currentTarget.parentElement.innerText;

    if (selectedOpt === "countries") {
      // searches the country object that matches the name on the box
      const country = countries.find((item) => item.name === selectedText);
      setSelected((prev) => ({ ...prev, country }));
    } else if (selectedOpt === "entities") {
      // searches the entity object that matches the name on the box
      const entity = entities.find((item) => item.entityName === selectedText);
      setSelected((prev) => ({ ...prev, entities: entity }));
    } else {
      // searches the office object that matches the name on the box
      const office = offices.find((item) => item.officeName === selectedText);
      setSelected((prev) => ({ ...prev, office }));
    }
  };

  const listByOpt =
    selectedOpt === "countries"
      ? countries
      : selectedOpt === "entities"
        ? entities
        : offices;

  const getItemContent = (item) => {
    if (selectedOpt === "countries") {
      return item.name;
    }

    if (selectedOpt === "entities") {
      return item.entityName;
    }

    return item.officeName;
  };

  return (
    <div className="admin-countries-offices d-flex flex-column flex-lg-row p-0 w-100">
      <Fade>
        {notif.msg && (
          <Notification
            type={{
              style: notif.type,
              icon: true,
            }}
            closable={false}
          >
            <span>{notif.msg}</span>
          </Notification>
        )}
      </Fade>
      <div className="co-list d-flex flex-wrap flex-sm-nowrap flex-lg-column">
        <div
          data-option="countries"
          onClick={changeSelected}
          className={(selectedOpt === "countries" ? "selected " : "").concat(
            "d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center gap-2"
          )}
        >
          <BsBuildings />
          <p>{t("countries")}</p>
        </div>
        <div
          data-option="entities"
          onClick={changeSelected}
          className={(selectedOpt === "entities" ? "selected " : "").concat(
            "d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center gap-2"
          )}
        >
          {/* <img alt="entity image" src={shield_person} /> */}
          <RiShieldUserLine />
          <p>{t("Entities")}</p>
        </div>
        <div
          data-option="offices"
          onClick={changeSelected}
          className={(selectedOpt === "offices" ? "selected " : "").concat(
            "d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center gap-2"
          )}
        >
          <BsGlobe />
          <p>{t("offices")}</p>
        </div>
      </div>
      <div className="co-contents">
        {!selectedOpt && (
          <div className="info d-flex justify-content-center align-items-center w-100 h-100">
            <div className="d-flex gap-1">
              <BsInfo className="mt-1" />
              <p className="p-0 m-0 text-center">{t("new_office_modal")}</p>
            </div>
          </div>
        )}
        {selectedOpt && (
          <div className="block-contents w-100">
            {listByOpt.map((item) => (
              <COSquare
                selectItem={selectItem}
                setEditMode={setEditMode}
                key={item.id}
                selectedOpt={selectedOpt}
                itemData={item}
                content={getItemContent(item)}
              />
            ))}
            {(selectedOpt === "offices" || selectedOpt === "entities") && (
              <button onClick={setCreateMode}>
                +&nbsp;
                {selectedOpt === "entities"
                    ? t("New_Entity")
                    : t("new_office")}
              </button>
            )}
          </div>
        )}
      </div>
      {visibleDialog.countries && (
        <CountriesDialog
          selected={selected.country}
          mode={mode}
          countries={countries}
          setCountries={setCountries}
          setNotif={setNotif}
          toggleDialog={toggleDialog}
        />
      )}
      {visibleDialog.offices && (
        <OfficesDialog
          mode={mode}
          setOffices={setOffices}
          setNotif={setNotif}
          toggleDialog={toggleDialog}
          offices={offices}
          selected={selected.office}
          countries={countries}
          getOffices={getOffices}
        />
      )}
      {visibleDialog.entities && (
        <EntitiesDialog
          mode={mode}
          selected={selected.entities}
          entities={entities}
          setEntities={setEntities}
          setNotif={setNotif}
          toggleDialog={toggleDialog}
          getEntities={getEntities}
        />
      )}
    </div>
  );
};

export default CountriesOffices;
